'use strict';

import React from 'react';
import Velocity from 'velocity-animate';

class Services extends React.Component {
  constructor(props) {
    super(props);
    this.animate = this.animate.bind(this);
  }

  animate() {
    let element = document.getElementById('service-rh');
    Velocity(element, {
      opacity: 0.5,
      position: 'absolute',
      transform: Velocity.scale()
    }, 1000);
  }

  render() {
    return (
      <div className="services-component" id="servicos">
        <h2 className="title section-title">Serviços</h2>
        <h4 className="title section-subtitle">
          Os serviços que prestamos destinam-se essencialmente para as seguintes
          entidades: Empresas; Empresários Com Contabilidade Organizada;
          Empresários Sem Contabilidade Organizada; Particulares.
        </h4>
        <div className="services-list">
          <div className="service">
            <div className="service-title">
              <img src="/static/images/contabilidadeefiscalidade.svg" />
              {/* <h5>Contabilidade e Fiscalidade</h5> */}
            </div>
            <div className="description">
              <h5>Contabilidade e Fiscalidade</h5>
              <ul>
                <li>Análise, classificação e registo informático em software certificado;</li>
                <li>Conciliação de contas correntes de clientes, fornecedores e outros devedores e credores diversos;</li>
                <li>Conciliação Bancária;</li>
                <li>Controlo e registo dos activos;</li>
                <li>Apoio à comunicação da faturação à AT;</li>
                <li>Apuramento e entrega das retenções de IRS e IRC;</li>
                <li>Apuramento e entrega dos pagamentos por conta e especiais por conta;</li>
                <li>Apuramento, preenchimento e entrega das declarações fiscais e obrigações declarativas (IVA / IRC / IES / IRS / Modelo 10 / Modelo 39);</li>
                <li>Emissão de mapas de contabilidade sempre que sejam solicitados pelo cliente;</li>
                <li>Análise e apresentação periódica da situação contabilística e fiscal da empresa;</li>
                <li>Elaborações do encerramento das contas e das demonstrações financeiras e anexos;</li>
                <li>Elaboração do dossier fiscal;</li>
                <li>Apoio à Elaboração do relatório de gestão e actas diversas;</li>
                <li>Elaboração das declarações de IRS dos sócios</li>
                <li>Deslocações mensais às instalações do cliente para obtenção dos documentos de suporte contabilístico;</li>
                <li>Deslocações regulares às finanças e outras entidades para efectuar pagamentos diversos, nomeadamente, IVAS, retenções, Taxa Social Única, entre outros.</li>
              </ul>
            </div>
          </div>
          <div className="services-small">
            <div className="service" id="service-rh">
              <div className="service-title">
                <img src="/static/images/recursoshumanos.svg" />
                <h5>Recursos Humanos</h5>
              </div>
              <ul className="description">
                <li>Processamento mensal de vencimentos;</li>
                <li>Inscrição dos trabalhadores na Segurança Social;</li>
                <li>Contratos de trabalho (temos acordos com advogados);</li>
                <li>Entrega das declarações de remunerações à Segurança Social e AT;</li>
                <li>Apuramento e entrega das retenções de IRS de Trabalho dependente;</li>
                <li>Apuramento e entrega dos Fundos de Compensação;</li>
                <li>Emissão das declarações anuais de Rendimentos individuais.</li>
                <li>Elaboração e entrega do Relatório Único.</li>
              </ul>
            </div>
            <div className="service">
              <div className="service-title">
                <img src="/static/images/outrosservicos.svg" />
                <h5>Outros Serviços</h5>
              </div>
              <ul className="description">
                <li>Elaboração e Entrega das declarações de IRS de particulares;</li>
                <li>Registo Automóvel;</li>
                <li>Seguros (intermediação com mediadores credenciados)</li>
              </ul>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

Services.displayName = 'Services';

// Uncomment properties you need
// Home.propTypes = {};
// Home.defaultProps = {};

export default Services;



// WEBPACK FOOTER //
// ./src/components/Services.js